var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 75,
    viewBox: "0 0 38 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.145708 0C-0.225292 0.211 0.240708 75.42 0.145708 75C10.0913 75 19.6296 71.0491 26.6622 64.0165C33.6948 56.9839 37.6457 47.4456 37.6457 37.5C37.6457 27.5544 33.6948 18.0161 26.6622 10.9835C19.6296 3.95088 10.0913 0 0.145708 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.537 48.727L25.984 46.265L16.907 37.365L25.992 28.454L23.533 26L12 37.359L23.537 48.727Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.645,
    height: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackLeft);
export default __webpack_public_path__ + "static/media/blackLeft.7dc4931ad8f74b2aa2f6959d8410686e.svg";
export { ForwardRef as ReactComponent };